import React from 'react'
import { displayField } from '../../../utils/utils'
import { Grid, Item } from 'semantic-ui-react'
import { activeAdminLink } from '../../../helpers/navigationHelpers'

export default class TooltipGridRow extends React.Component {
  render() {
    const { id, labelWidth, attrWidth, data } = this.props

    return (
      <React.Fragment>
        {data.map((obj, i) => {return (
          <Grid.Row key={`tooltip-grid-row-${i}`} style={{paddingTop: 0, paddingBottom: 0}}>
            <Grid.Column width={labelWidth}>
              <Item>
                <strong>{obj.label}</strong>
              </Item>
            </Grid.Column>
            <Grid.Column width={attrWidth}>
              <Item>
                { obj.label == "Shop:" ? ( <a href={activeAdminLink(`shops/${id}`)} rel='noopener noreferrer' target='_blank'>{displayField(obj.attr)}</a>) : (displayField(obj.attr))
                }
              </Item>
            </Grid.Column>
          </Grid.Row>
        )})}
      </React.Fragment>

    )
  }
}